<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<div class="request-list data-list-container">
		<div class="dropdown-button-container flex justify-end mt-16 md:hidden lg:hidden xl:hidden">
			<!-- <vs-input @input="mixinHandleSearch" size="large" class="input-search mr-3" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" /> -->

			<vs-dropdown vs-custom-content vs-trigger-click>
				<vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
				<vs-dropdown-menu>
					<vs-dropdown-item>
						<vs-button class="w-48 font-bold mr-3" type="border" @click="toggleFilterDialog(true)">{{ $t("Filter") }}</vs-button>
					</vs-dropdown-item>

					<vs-dropdown-item divider>
						<vs-button class="w-48 font-bold" type="filled" @click="addNewRequest">{{ $t("Actions.AddNew") }}</vs-button>
					</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>

		<div class="flex flex-col items-end">
			<div class="flex flex-grow">
				<!-- <vs-input size="large" icon="search" class="input-search mr-3 md:block lg:block xl:block hidden" :placeholder="$t('Actions.Search')" v-model="searchText" @input="mixinHandleSearch" /> -->

				<div class="md:flex lg:flex xl:flex hidden">
					<cbs-download-button
						class="mr-3"
						v-if="filterData && filterData.simpleFilter && filterData.simpleFilter.type"
						:btnText="$t('Actions.Download')"
						@click.stop="handleExportFilteredData"
					/>
					<vs-input @input="mixinHandleSearch" size="large" class="input-search mr-3" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />
					<vs-button class="w-48 font-bold mr-3" type="border" @click="toggleFilterDialog(true)">{{ $t("Filter") }}</vs-button>
					<vs-button class="w-48 font-bold" type="filled" @click="addNewRequest">{{ $t("Actions.AddNew") }}</vs-button>
				</div>
			</div>
			<!-- Status Group -->
			<!-- <div class="w-full flex flex-grow justify-between items-center mt-5 pb-5" v-if="isShowListCount">
				<div class="lg:flex flex-grow justify-start w-full">
					<vs-button
						v-for="(tag, idx) in listCountMixin"
						:key="`tag${idx}`"
						:color="isActiveTag(tag.id) ? '#2B59B2' : '#828282'"
						type="border"
						:class="['mr-3 border-2', { 'font-bold': isActiveTag(tag.id), notActive: !isActiveTag(tag.id) }]"
						@click="handleFilterStatus(tag.id)"
					>
						<p :class="['whitespace-no-wrap', { 'text-primary': isActiveTag(tag.id) }]">{{ tag.name }} ({{ tag.display }})</p>
					</vs-button>
				</div>
			</div> -->
			<div slot="header" class="w-full flex flex-grow justify-between items-center mt-5 pb-5">
				<div class="lg:flex flex-grow justify-start w-full">
					<vs-button
						v-for="(tag, idx) in listCountMixin"
						:key="`tag${idx}`"
						:color="isActiveTag(tag.id) ? '#2B59B2' : '#828282'"
						type="border"
						:class="['mr-3 border-2', { 'font-bold': isActiveTag(tag.id), notActive: !isActiveTag(tag.id) }]"
						@click="handleFilterStatus(tag.id)"
					>
						<p :class="['whitespace-no-wrap', { 'text-primary': isActiveTag(tag.id) }]">{{ tag.name }} ({{ tag.display }})</p>
					</vs-button>
				</div>
				<!-- Button Group -->
				<div class="flex flex-grow justify-between items-center mt-5 pb-5">

					<div>
						<ColumnContextMenu @onChangeSort="handleSort" />
					</div>
				</div>
			</div>
			<!--End Status Group -->
		</div>

		<request-table
			:key="activeTime"
			:data="requestsMixin"
			:displayColumns="displayColumns"
			@onSortChange="mixinHandleSort"
			@onClickRowItem="handleClickRowItemMixin"
			@onSetMarkedColor="handleSetMarkedColorMixin"
			@onClickDuplicate="handleClickDuplicateRequest"
			@onClickDownload="handleClickDownloadRequest"
			@onClickCreateTodo="handleClickCreateTodoMixin"
			@onClickCancelMenu="handleClickCancelRequestMixin"
			@onClickRecreateMenu="handleClickRecreateRequestMenuMixin"
			@onClickApproveOrRejectConfirm="handleClickApproveOrRejectMixin"
		/>

		<cbs-pagination class="mt-3" :total="totalPages" v-model="currentPage" />

		<request-form-dialog
			v-if="isShowRequestFormDialogMixin"
			v-model="activeRequestMixin"
			:stepsData="stepsDataMixin"
			:activeStepId="activeStepIdMixin"
			:requestTypes="requestTypesMixin"
			:isDialogActive="isShowRequestFormDialogMixin"
			:key="activeRequestMixin && activeRequestMixin.id ? activeRequestMixin.id : 'default'"
			@onClickExportData="handleExportDataMixin"
			@closeDialog="toggleRequestFormDialogMixin"
			@onClickStepItem="handleClickStepItemMixin"
			@onIsFormDirtyChange="handleSetIsFormDirty"
			@onClickCreateTodo="handleClickCreateTodoMixin"
			@onClickDuplicate="handleClickDuplicateRequest"
			@onChangeRequestType="handleChangeRequestTypeMixin"
			@onClickSubmit="handleClickSubmitRequestFormDialog"
			@onDialogClose="handleSetInitRequestFormDialogMixin"
			@onClickCancelRequest="handleClickCancelRequestMixin"
			@onClickRecreateRequest="handleClickRecreateRequestMixin"
			@onClickApproveOrReject="handleClickApproveOrRejectMixin"
			@onFocusSelectRequestTypes="handleOnFocusSelectRequestTypesMixin"
		/>

		<request-approve-or-reject-confirm-dialog
			v-if="isShowApproveOrRejectDialogMixin"
			v-model="approveOrRejectDataMixin"
			:isAgree="approveOrRejectStatusMixin"
			:isDialogActive="isShowApproveOrRejectDialogMixin"
			@onClickCancel="toggleApproveOrRejectDialogMixin(false)"
			@onClickConfirm="handleClickConfirmApproveOrRejectDialogMixin"
		/>

		<request-cancel-confirm-dialog
			v-model="cancelRequestDataMixin"
			:isDialogActive="isShowCancelRequestDialogMixin"
			@onClickCancel="toggleCancelRequestDialogMixin(false)"
			@onClickConfirm="handleClickConfirmCancelRequestMixin"
		/>

		<todo-list-form-sidebar
			:data="todoFormDialogDataMixin"
			:categoryId="$constant.TODO_CATEGORY.NORMAL"
			:isSidebarActive="isShowCreateTodoDialogMixin"
			@closeSidebar="toggleCreateTodoFormDialogMixin"
			@onCreateOrUpdateSuccess="handleOnCreateTodoSuccessMixin"
		/>

		<request-approver-dialog
			v-if="isShowApproverDialogMixin"
			:isApprovable="true"
			:value="approverDialogDataMixin"
			:title="requestApproverDialogTitleMixin"
			:isDialogActive="isShowApproverDialogMixin"
			:isEditable="requestApproverDialogEditableMixin"
			:requestPurpose="approverDialogDataMixin.request_reason || null"
			:mappedAttachObj="requestApproverDialogMappedAttachsDataObjMixin"
			@closeDialog="toggleApproverDialogMixin"
			@cancelRequest="handleClickCancelRequestMixin"
			@onClickCreateTodo="handleClickCreateTodoMixin"
			@onClickDuplicate="handleClickDuplicateRequest"
			@handleClickEdit="handleShowRequestFormDialogMixin"
			@handleClickApproveOrReject="handleClickApproveOrRejectMixin"
		/>

		<request-filter-dialog
			v-model="filterData"
			:isDialogActive="isShowFilterDialog"
			@closeDialog="toggleFilterDialog"
			@onApplyFilter="handleApplyFilter"
			@onClickExport="handleExportFilteredStatisticData"
		/>
	</div>
</template>

<script>
import moment from "moment";
import { get as lodashGet } from "lodash";
import * as _ from "lodash";
import requestGQL from "@/http/requests/request/request_v2_gql";
import requestBasicHandlers from "@/mixins/requestBasicHandlers";
import { withBasicQueries, detectLeavePage } from "@/mixins/mixins.js";

import RequestTable from "@/components/cbs-request/RequestTable";
import RequestFormDialog from "@/components/cbs-request/RequestFormDialog";
import RequestFilterDialog from "@/components/cbs-request/RequestFilterDialog";
import TodoListFormSidebar from "@/views/apps/cbs/todo-list/TodoListFormSidebar";
import RequestApproverDialog from "@/components/cbs-request/RequestApproverDialog";
import RequestCancelConfirmDialog from "@/components/cbs-request/RequestCancelConfirmDialog";
import RequestApproveOrRejectConfirmDialog from "@/components/cbs-request/RequestApproveOrRejectConfirmDialog";


import ColumnContextMenu from "./ColumnContextMenu";

const initFilterData = {
	simpleFilter: {
		type: null,
		status: null,
		creator: null,
		createdDate: [],
		department_ids: []
	},
	advancedFilter: []
};

export default {
	name: "RequestList",
	mixins: [withBasicQueries, requestBasicHandlers, detectLeavePage("isRequestFormDirty")],
	components: {
		RequestTable,
		RequestFormDialog,
		TodoListFormSidebar,
		RequestFilterDialog,
		RequestApproverDialog,
		RequestCancelConfirmDialog,
		RequestApproveOrRejectConfirmDialog,

		ColumnContextMenu
	},
	data() {
		return {
			limit: 20,
			filterData: { ...initFilterData },
			totalRequests: null,

			isRequestFormDirty: false,
			isShowFilterDialog: false,
			isShowListCount: true,
			displayColumns: {},
			activeTime: (new Date).getTime()
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.totalRequests / this.limit);
		},
		requestFilterType() {
			const routePath = this.$route && this.$route.path;
			if (routePath === this.$constant.PAGES_PATH.PAGE_CBS_REQUESTS_CREATED_BY_ME_PATH || routePath === this.$constant.PAGES_PATH.PAGE_CBS_REQUESTS_RELATING_TO_ME_PATH || routePath === this.$constant.PAGES_PATH.PAGE_CBS_REQUESTS_APPROVE_BY_ME_PATH) {
				const filterType = routePath && routePath.split("/");
				return filterType && filterType.length && filterType[filterType.length - 1];
			}
			return null;
		},
		mappedFilterObj() {
			const type = lodashGet(this.filterData, "simpleFilter.type.id") || null;
			const color = lodashGet(this.filterData, "simpleFilter.flagColor") || null;
			const status = lodashGet(this.filterData, "simpleFilter.status") || [];
			const creator = lodashGet(this.filterData, "simpleFilter.creator") || [];
			const createdDate = lodashGet(this.filterData, "simpleFilter.createdDate") || [];
			const department_ids = lodashGet(this.filterData, "simpleFilter.department_ids") || [];
			const advancedFilter = lodashGet(this.filterData, "advancedFilter") || [];
			const mappedAdvancedFilterObj = {};
			advancedFilter.forEach(obj => {
				mappedAdvancedFilterObj[obj.id] = obj.value;
				if (
					obj.control === this.$constant.request.control.dropdown ||
					obj.control === this.$constant.request.control.relation ||
					obj.control === this.$constant.request.control.checkbox ||
					obj.control === this.$constant.request.control.radio
				) {
					mappedAdvancedFilterObj[obj.id] = obj.value.map(item => item.id);
				}

				if (obj.control === this.$constant.request.control.datetime) {
					mappedAdvancedFilterObj[obj.id] = [obj.value[0] ? moment(obj.value[0]).toISOString() : null, obj.value[1] ? moment(obj.value[1]).toISOString() : null];
				}
			});

			return {
				req_type_id: type,
				user_option_color: color,
				list_statuses: status,
				list_requested_by: creator.map(item => item.id),
				advantage_search: JSON.stringify(mappedAdvancedFilterObj),
				to_date: createdDate[1] ? moment(createdDate[1]).toISOString() : null,
				from_date: createdDate[0] ? moment(createdDate[0]).toISOString() : null,
				department_ids: department_ids
			};
		}
	},
	watch: {
		"$route.query"(newVal, oldVal) {
			const newValClone = Object.assign({}, newVal);
			const oldValClone = Object.assign({}, oldVal);
			if (!newValClone.id) {
				delete oldValClone.id;
			}
			if (JSON.stringify(newValClone) !== JSON.stringify(oldValClone)) {
				this.handleFetchDataByQuery();
			}
		},
		requestFilterType() {
			this.filterData = { ...initFilterData };
		},
		isShowRequestFormDialogMixin() {
			// reset detailId and query id when close request form dialog
			if (!this.isShowRequestFormDialogMixin) {
				this.detailId = null;
				this.handleSetIsFormDirty(false);
			}
		}
	},
	methods: {
		getDisplayColumns() {
			let map = {};
			let data = [
				{ label: 'code', column: "code"},
				{ label: 'Proposer', column: "requester", checked: '1'},
				{ label: 'RequestType', column: "reqtype", checked: '1' },
				{ label: 'Purpose', column: "request_reason", checked: '1' },
				{ label: 'CreatedDate', column: "created_at", checked: '1' },
				{ label: 'Status', column: "reqstatus", checked: '1' },
				{ label: 'Number', column: "number" },
			];

			data.forEach(item => {
				let key = `STORE_REQ_${item.column}`;
				let value = null;
				if (localStorage) {
					value = localStorage.getItem(key);
					if (value != null) {
						item.checked = value ? '1' : '';
					}
				}
				map[item.column] = item.checked;
			})
			this.displayColumns = map;
		},
		handleSort(data) {
			this.displayColumns = data;
			this.activeTime = (new Date).getTime();
		},
		checkCanApprove(response) {
			let isActiveRequestApprovable = true;
			if (response.reqstatus && response.reqstatus.approverFillInfo) {
				isActiveRequestApprovable = !!(response.reqstatus && response.reqstatus.status === 0 && response.can_edit);
				if (response.data) {
					let dataObj = JSON.parse(response.data);
					if (dataObj) {
						if (!dataObj.hasOwnProperty("child")) {
							isActiveRequestApprovable = false;
						}
					}
				}
			}
			return isActiveRequestApprovable;
		},
		async getRequests(quickStatusFilter = null) {
			try {
				this.$vs.loading();

				const queryOptions = {
					limit: this.limit,
					orderBy: this.orderBy,
					page: this.currentPage,
					...this.mappedFilterObj
				};

				if (quickStatusFilter !== null && quickStatusFilter !== undefined) {
					queryOptions.list_statuses = quickStatusFilter;
				}

				if (this.requestFilterType && this.$constant.REQUEST_FILTER_TYPE.hasOwnProperty(this.requestFilterType)) {
					// queryOptions.requested_by_me = this.$constant.REQUEST_FILTER_TYPE[this.requestFilterType];
					queryOptions[this.requestFilterType.replace(/-/g, '_')] = this.$constant.REQUEST_FILTER_TYPE[this.requestFilterType];
					this.isShowListCount = false;
				}

				if (this.searchText) {
					queryOptions.search = this.searchText;
				}

				// Fetch requestList
				const response = await requestGQL.getRequests(queryOptions);
				this.totalRequests = response.total;
				this.requestsMixin = response.data || [];
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleFetchDataByQuery() {
			this.getRequests().then(() => {
				if (this.$route.query.id) {
					this.handleClickRowItemMixin({ id: this.$route.query.id });
				}
			});
			this.getRequestStatusCount();
		},
		async toggleFilterDialog(val = false) {
			this.isShowFilterDialog = val;
		},
		async handleExportFilteredData() {
			try {
				this.$vs.loading();
				const response = await requestGQL.exportFilteredRequest(this.mappedFilterObj);
				const fileName = response.split("/");
				await this.handleDownloadFile({
					path: response,
					file_name: fileName[fileName.length - 1]
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleExportFilteredStatisticData() {
			try {
				this.$vs.loading();
				const response = await requestGQL.exportFilteredRequestStatistic(this.mappedFilterObj);
				const fileName = response.split("/");
				await this.handleDownloadFile({
					path: response,
					file_name: fileName[fileName.length - 1]
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleApplyFilter(filter) {
			this.currentPage = 1;
			this.filterData = filter;
			this.getRequests();
		},
		addNewRequest() {
			this.handleSetInitRequestFormDialogMixin();
			this.toggleRequestFormDialogMixin(true);
		},
		async handleClickSubmitRequestFormDialog(requestData, dynamicStepConfig, relationsData, resolve, reject) {
			await this.handleClickSubmitRequestFormDialogMixin(requestData, dynamicStepConfig, relationsData, resolve, reject);
			this.getRequests();
		},
		handleSetIsFormDirty(isFormDirty) {
			this.isRequestFormDirty = isFormDirty;
		},
		handleFilterStatus(requestStatus) {
			let status = _.cloneDeep(this.filterData.simpleFilter.status);
			status = status ? status : [];
			const idx = _.indexOf(status, requestStatus);
			if (idx !== -1) {
				status.splice(idx, 1);
			} else {
				status.push(requestStatus);
			}
			this.filterData.simpleFilter.status = status;
			this.getRequests(status);
		},
		async handleClickDuplicateRequest(requestId) {
			await this.handleClickDuplicateRequestMixin(requestId);
			this.getRequests();
		},
		async handleClickDownloadRequest(requestId) {
			try {
				this.$vs.loading();
				const response = await requestGQL.exportRequest(requestId);
				const fileName = response.split("/");
				await this.handleDownloadFile({
					path: response,
					file_name: fileName[fileName.length - 1]
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		isActiveTag(id) {
			return this.filterData.simpleFilter.status ? this.filterData.simpleFilter.status.includes(id) : false;
		}
	},
	created() {
		this.getDisplayColumns();
		this.handleFetchDataByQuery();
	}
};
</script>
